let body = null;
let languageCode = null;

/**
 * Get body element.
 * @returns {Element}
 */
function getBody() {
    if (body === null) {
        body = document.querySelector('body');
    }

    return body;
}

function getLanguageCode() {
    if (languageCode === null) {
        languageCode = document.documentElement.lang.split('-')[0];
    }

    return languageCode;
}

function getMetaValue(metaName) {
    const metaEl = document.querySelector(`meta[name='${metaName}']`);
    if (!metaEl) {
        return '';
    }

    return metaEl.getAttribute('content');
}

/**
 * Get ancestor element by conditional check.
 * @param {Element} el - Element to start search from - inclusive.
 * @param {Function} conditionFn
 * @returns {Element|HTMLElement|undefined}
 */
function getAncestor(el, conditionFn) {
    let current = el;

    while (current) {
        if (conditionFn(current)) {
            return current;
        } else if (current.nodeName === 'BODY') {
            return undefined;
        }

        current = current.parentElement;
    }

    return undefined;
}

export {
    getBody,
    getLanguageCode,
    getMetaValue,
    getAncestor,
};
